import { render, staticRenderFns } from "./footerLink.vue?vue&type=template&id=651217bf&scoped=true&"
import script from "./footerLink.vue?vue&type=script&lang=js&"
export * from "./footerLink.vue?vue&type=script&lang=js&"
import style0 from "./footerLink.vue?vue&type=style&index=0&id=651217bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651217bf",
  null
  
)

export default component.exports